import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PatientsPagination from "../PatientsPagination/PatientsPagination";
import ModalDialog from "../ModalDialog/ModalDialog";
import Spinner from "../Spinner/Spinner";
import { RootState } from "@/store/store";
import { setIsVisibleModalDialog } from "@/store/ui/ui";
import { setPatientId } from "@/store/patients/patients";
import useDeleteEntity from "@/hooks/useDeleteEntity";
import { deleteAppointmentOnUserpage } from "@/store/patients/patients";
import { toast } from "react-toastify";
import useGetRole from "@/hooks/useGetRole";
import { adminMessage } from "@/utils/constants";
import PatientAppointmentItem from "../PatientAppointmentItem/PatientAppointmentItem";

export default function PatientDetailsPageAppsList() {
    const [activepage, setActivePage] = useState<number>(1);
    const dispatch = useDispatch();
    const { isAdmin } = useGetRole();
    const patientId = useSelector(
        (state: RootState) => state.patients.patientId,
    );
    const appointments = useSelector(
        (state: RootState) => state.patients.appointments,
    );
    const selectedPatient = useSelector(
        (state: RootState) => state.patients.selectedPatient,
    );
    const { handleDelete } = useDeleteEntity();
    const limitPage = 9;

    const currentAppointments = (appointments ?? []).slice(
        (activepage - 1) * limitPage,
        activepage * limitPage,
    );

    const handleChangeActivepage = (
        event: React.ChangeEvent<unknown>,
        value: number,
    ) => {
        setActivePage(value);
    };

    const handleOpen = (id: string) => {
        if (isAdmin) {
            dispatch(setPatientId(id));
            dispatch(setIsVisibleModalDialog(true));
        } else toast.error(adminMessage);
    };

    const handleDeletePatientsAppointment = async () => {
        await handleDelete({
            entity: "appointments",
            id: patientId,
            onSuccess: () => {
                dispatch(setIsVisibleModalDialog(false));
                dispatch(deleteAppointmentOnUserpage(patientId));
            },
            message: "Візит пацієнта успішно видалено",
            isLocalLoading: true,
        });
        dispatch(setPatientId(""));
    };

    return (
        <section className='listing_container'>
            <div>
                {currentAppointments.length > 0 ? (
                    currentAppointments.map((appointment, index) => (
                        <PatientAppointmentItem
                            key={appointment._id}
                            appointment={appointment}
                            index={index}
                            handleOpen={handleOpen}
                        />
                    ))
                ) : (
                    <p className='no_paragraf'>Візити відсутні</p>
                )}
            </div>

            {currentAppointments.length > 0 && (
                <PatientsPagination
                    localdataLength={appointments?.length}
                    activepage={activepage}
                    handleChangeActivepage={handleChangeActivepage}
                    limitPage={limitPage}
                />
            )}

            <ModalDialog
                onConfirm={handleDeletePatientsAppointment}
                title='Видалити візит пацієнта?'
                message={`Ви впевнені, що хочете видалити візит?`}
            />
            <Spinner />
        </section>
    );
}
